import { render, staticRenderFns } from "./NotaFiscalItemProdutos.vue?vue&type=template&id=59504d14&"
import script from "./NotaFiscalItemProdutos.vue?vue&type=script&lang=js&"
export * from "./NotaFiscalItemProdutos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
